<template>
  <div>
    <!-- <v-parallax dark :src="require('../../assets/slide-2.jpg')">
      <v-layout align-center column justify-center>
        <h1 class="display-2 font-weight-thin mb-3">Don Fruta</h1>
        <h4 class="subheading">源生态水果 绿色好健康</h4>
      </v-layout>
    </v-parallax> -->

    <swiper
      :options="swiperOption"
      ref="mySwiper"
      @someSwiperEvent="handleSwiper"
    >
      <!-- slides -->
      <swiper-slide v-for="(item, index) in adSwiperList" :key="index">
        <div @click="loadGoodsSeriesList(item)">
          <img class="home-img" :src="item.img" />
        </div>
      </swiper-slide>
      <!-- Optional controls -->
      <div class="swiper-pagination" slot="pagination"></div>
      <!-- <div class="swiper-button-prev" slot="button-prev"></div> -->
      <!-- <div class="swiper-button-next" slot="button-next"></div> -->
      <!-- <div class="swiper-scrollbar" slot="scrollbar"></div> -->
    </swiper>

    <a :key="index" v-for="(item, index) in adTopList" :href="item.linkUrl">
      <img class="home-img" :src="item.img" />
    </a>

    <div class="latest-news">
      <a
        class="news-img"
        :key="index"
        v-for="(item, index) in adBottomList"
        :href="item.linkUrl"
      >
        <img class="home-img" :src="item.img" />
      </a>
    </div>
  </div>
</template>

<script>
import common from "../../api/common.js";

export default {
  data() {
    return {
      adTopList: [],
      adBottomList: [],
      goodsSeriesList: [],
      adSwiperList: [],
      swiperOption: {
        autoplay: true,
        pagination: {
          el: ".swiper-pagination"
        }
      }
    };
  },
  mounted() {
    this.loadIndexAd();
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper.swiper;
    }
  },
  methods: {
    async loadIndexAd() {
      try {
        const res = await common.loadIndexAd({ type: "index" });
        if (res.data.status == "fail") {
          this.$toasted.show(res.data.msg);
        } else if (res.data.status == "SUCCESSS") {
          this.adTopList = res.data.data.pcIndex2.ads;
          this.adBottomList = res.data.data.pcIndex7.ads;
          this.adSwiperList = res.data.data.pcIndex8.ads;
        }
      } catch (e) {
        console.log(e);
      }
    },

    loadGoodsSeriesList(item) {
      if (item.linkType != "goodsSeries") {
        if (item.linkUrl) {
          window.location.href = item.linkUrl;
        }
      } else {
        this.$router.push({ name: "series", params: { adId: item.adId } });
      }
    },

    handleSwiper(e) {
      console.log(e);
    }
  }
};
</script>
<style scoped lang="sass" src="./home.sass"></style>
